var brand = "Brand",
  model = "Model",
  version = "Version",
  generation = "Generation",
  type = "Type";
function translateText() {
  "et" === Shopify.locale
    ? ((brand = "Tootja"),
      (model = "Mudel"),
      (version = "Versioon"),
      (generation = "Generatsioon"),
      (type = "Tüüp"))
    : ((brand = "Brand"),
      (model = "Model"),
      (version = "Version"),
      (generation = "Generation"),
      (type = "Type"));
}
function getCarData() {
  return fetch(
    "https://cdn.shopify.com/s/files/1/0821/7968/6739/files/maxtonCarBrands.json"
  )
    .then(function (e) {
      if (!e.ok) throw new Error("HTTP error! Status: " + e.status);
      return e.json();
    })
    .catch(function (e) {
      throw (
        (console.error("Error fetching car data: ", e),
        new Error("Error fetching car data: " + e))
      );
    });
}
function manualSort(e) {
  for (var n = 0; n < e.length - 1; n++)
    for (var t = n + 1; t < e.length; t++)
      if (e[n].brand > e[t].brand) {
        var a = e[n];
        (e[n] = e[t]), (e[t] = a);
      }
}
function findBrandByName(e, n) {
  for (var t = 0; t < e.length; t++) if (e[t].brand === n) return e[t];
  return null;
}
function findModelByName(e, n) {
  if (!e || !e.models) return null;
  for (var t = 0; t < e.models.length; t++)
    if (e.models[t].model === n) return e.models[t];
  return null;
}
function findVersionByName(e, n) {
  if (!e || !e.versions) return null;
  for (var t = 0; t < e.versions.length; t++)
    if (e.versions[t].version === n) return e.versions[t];
  return null;
}
function findGenerationByName(e, n) {
  if (!e || !e.generations) return null;
  for (var t = 0; t < e.generations.length; t++)
    if (e.generations[t].generation === n) return e.generations[t];
  return null;
}
function findTypeByName(e, n) {
  if (!e || !e.types) return null;
  for (var t = 0; t < e.types.length; t++)
    if (e.types[t].type === n) return e.types[t];
  return null;
}
function populateOptions() {
  try {
    getCarData().then(function (e) {
      var n = document.getElementById("maxton_brand"),
        t = document.getElementById("maxton_model"),
        a = document.getElementById("maxton_version"),
        r = document.getElementById("maxton_generation"),
        o = document.getElementById("maxton_type");
      manualSort(e);
      for (var i = 0; i < e.length; i++) {
        var d = e[i].brand,
          l = document.createElement("option");
        (l.text = d), (l.value = d), n.add(l);
      }
      (t.disabled = !0),
        (a.disabled = !0),
        (r.disabled = !0),
        (o.disabled = !0);
      var s,
        u = getFromLocalStorage(n.id),
        c = getFromLocalStorage(t.id),
        v = getFromLocalStorage(a.id),
        f = getFromLocalStorage(r.id),
        m = getFromLocalStorage(o.id);
      (n.addEventListener("change", function () {
        translateText();
        var i = n.value;
        if (i) {
          (t.disabled = !0),
            (a.disabled = !0),
            (r.disabled = !0),
            (o.disabled = !0),
            (t.disabled = !1);
          var d = findBrandByName(e, i);
          if (
            ((t.innerHTML =
              "<option value='' disabled selected>" + model + "</option>"),
            (a.innerHTML =
              "<option value='' disabled selected>" + version + "</option>"),
            (r.innerHTML =
              "<option value='' disabled selected>" + generation + "</option>"),
            (o.innerHTML =
              "<option value='' disabled selected>" + type + "</option>"),
            d && d.models)
          ) {
            var l = d.models.map(function (e) {
              return e.model;
            });
            l.sort(function (e, n) {
              return e.localeCompare(n);
            }),
              l.forEach(function (e) {
                var n = document.createElement("option");
                (n.text = e), (n.value = e), t.add(n);
              });
          } else t.disabled = !0;
        } else (t.disabled = !0), (a.disabled = !0), (r.disabled = !0), (o.disabled = !0);
      }),
      t.addEventListener("change", function () {
        translateText();
        var i = t.value;
        if (i) {
          (a.disabled = !0),
            (r.disabled = !0),
            (o.disabled = !0),
            (a.disabled = !1);
          var d = findModelByName(findBrandByName(e, n.value), i);
          if (
            ((a.innerHTML =
              "<option value='' disabled selected>" + version + "</option>"),
            (r.innerHTML =
              "<option value='' disabled selected>" + generation + "</option>"),
            (o.innerHTML =
              "<option value='' disabled selected>" + type + "</option>"),
            d && d.versions)
          ) {
            var l = d.versions.map(function (e) {
              return e.version;
            });
            l.sort(function (e, n) {
              return e.localeCompare(n);
            }),
              l.forEach(function (e) {
                var n = document.createElement("option");
                (n.text = e), (n.value = e), a.add(n);
              });
          } else a.disabled = !0;
        } else (a.disabled = !0), (r.disabled = !0), (o.disabled = !0);
      }),
      a.addEventListener("change", function () {
        translateText();
        var i = a.value;
        if (i) {
          (r.disabled = !0), (o.disabled = !0), (r.disabled = !1);
          var d = findVersionByName(
            findModelByName(findBrandByName(e, n.value), t.value),
            i
          );
          if (
            ((r.innerHTML =
              "<option value='' disabled selected>" + generation + "</option>"),
            (o.innerHTML =
              "<option value='' disabled selected>" + type + "</option>"),
            d && d.generations)
          ) {
            var l = d.generations.map(function (e) {
              return e.generation;
            });
            l.sort(function (e, n) {
              return e.localeCompare(n);
            }),
              l.forEach(function (e) {
                var n = document.createElement("option");
                (n.text = e), (n.value = e), r.add(n);
              });
          } else r.disabled = !0;
        } else (r.disabled = !0), (o.disabled = !0);
      }),
      r.addEventListener("change", function () {
        translateText();
        var i = r.value;
        if (i) {
          (o.disabled = !0), (o.disabled = !1);
          var d = findGenerationByName(
            findVersionByName(
              findModelByName(findBrandByName(e, n.value), t.value),
              a.value
            ),
            i
          );
          if (
            ((o.innerHTML =
              "<option value='' disabled selected>" + type + "</option>"),
            d && d.types)
          ) {
            var l = d.types.map(function (e) {
              return e.type;
            });
            l.sort(function (e, n) {
              return e.localeCompare(n);
            }),
              l.forEach(function (e) {
                var n = document.createElement("option");
                (n.text = e), (n.value = e), o.add(n);
              });
          } else o.disabled = !0;
        } else o.disabled = !0;
      }),
      containsPathSegment(window.location.href, "search")) &&
        (null != u &&
          null != findBrandByName(e, u) &&
          ((n.value = u),
          (s = document.createEvent("HTMLEvents")).initEvent("change", !1, !0),
          n.dispatchEvent(s)),
        null != c &&
          ((t.value = c),
          (s = document.createEvent("HTMLEvents")).initEvent("change", !1, !0),
          t.dispatchEvent(s)),
        null != v &&
          ((a.value = v),
          (s = document.createEvent("HTMLEvents")).initEvent("change", !1, !0),
          a.dispatchEvent(s)),
        null != f &&
          ((r.value = f),
          (s = document.createEvent("HTMLEvents")).initEvent("change", !1, !0),
          r.dispatchEvent(s)),
        null != m && (o.value = m));
    });
  } catch (e) {
    throw (
      (console.error("Error populating car data: ", e),
      new Error("Error populating car data: " + e))
    );
  }
}
function getFromLocalStorage(e) {
  return localStorage.getItem(e);
}
function containsPathSegment(e, n) {
  try {
    return new URL(e).pathname.includes(n);
  } catch (e) {
    return !1;
  }
}
populateOptions();
